import { Node as ProseMirrorNode, type DOMOutputSpec } from '@tiptap/pm/model';
import { convertToPt } from '../../extension-word/utils';
import { analyzeTableStructure } from './tableUtils';

export type ColGroup =
    | {
          colgroup: DOMOutputSpec;
          colgroupWithStyle: DOMOutputSpec;
          colgroupElement: HTMLTableColElement;
      }
    | Record<string, never>;

export function createColGroup(tableNode: ProseMirrorNode, pos: number): ColGroup {
    const row = tableNode.firstChild;

    if (!row) {
        return {};
    }

    const tableStructure = analyzeTableStructure(tableNode, pos);
    const cols: DOMOutputSpec[] = tableStructure.colgroup;

    const colgroup: DOMOutputSpec = ['colgroup', {}, ...cols];
    const colgroupWithStyle: DOMOutputSpec = ['colgroup', {}, ...cols.map(col => (col[1]?.width && convertToPt(col[1]?.width) > 0 ? ['col', { style: `width: ${col[1]?.width}` }] : ['col']))];
    const colgroupElement = document.createElement('colgroup');
    for (let i = 0; i < cols.length; i += 1) {
        const col = cols[i];
        const colElement = document.createElement('col');
        if (col[1]?.width && convertToPt(col[1]?.width) > 0) {
            colElement.style.width = col[1].width;
            if (!tableNode.attrs.allowAutoFit && tableNode.attrs.width.value === 0) {
                colElement.style.minWidth = col[1].width;
                colElement.style.maxWidth = col[1].width;
            }
        }
        colgroupElement.appendChild(colElement);
    }
    return { colgroup, colgroupWithStyle, colgroupElement };
}
